module.exports = "<!-- aside app.setting.asideFolded || $state.current.data.folded -->\n\n<!-- content -->\n<div id=\"header\" class=\"app-content-header\" role=\"main\"  ui-view=\"header@\">\n</div>\n<!-- / content -->\n\n\n<md-sidenav id=\"aside\" class=\"app-aside md-sidenav-left\" ng-class=\"{'folded': app.setting.asideFolded}\" ui-view=\"aside@\" md-component-id=\"aside\">\n</md-sidenav>\n<!-- / aside -->\n\n<!-- content -->\n<div id=\"content\" class=\"app-content\" role=\"main\"  ui-view=\"content@\">\n</div>\n<!-- / content -->\n\n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/layout/layout.html
// module id = 83
// module chunks = 0